var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-card",
    [
      _c(
        "div",
        { staticClass: "d-flex justify-content-center" },
        [
          _vm.showSpinner
            ? _c("b-spinner", {
                staticStyle: { width: "3rem", height: "3rem" },
                attrs: { variant: "success", label: "Spinning" },
              })
            : _vm._e(),
        ],
        1
      ),
      !_vm.showSpinner
        ? _c(
            "b-media",
            { attrs: { "no-body": "" } },
            [
              _c(
                "b-media-aside",
                [
                  _c(
                    "b-link",
                    [
                      _vm.generalData.imageUrl && _vm.imageFile === null
                        ? _c("b-img", {
                            ref: "previewEl",
                            attrs: {
                              rounded: "",
                              src: _vm.getUrlImage(_vm.generalData.imageUrl),
                              height: "80",
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                  _c(
                    "b-link",
                    [
                      _vm.imageFile != null && _vm.imageFile.length != 0
                        ? _c("b-img", {
                            ref: "previewEl",
                            attrs: {
                              rounded: "",
                              src: _vm.imageFile,
                              height: "80",
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "b-media-body",
                { staticClass: "mt-75 ml-75" },
                [
                  _c(
                    "label",
                    {
                      directives: [
                        {
                          name: "b-tooltip",
                          rawName: "v-b-tooltip.hover.v-dark",
                          modifiers: { hover: true, "v-dark": true },
                        },
                      ],
                      staticClass: "custom-file-upload text-white mb-75 mr-75",
                      attrs: {
                        for: "file-upload",
                        variant: "outline-secondary",
                        title: "Upload Company Logo",
                      },
                    },
                    [_vm._v(" Upload ")]
                  ),
                  _c("input", {
                    attrs: {
                      id: "file-upload",
                      type: "file",
                      accept: "image/jpg, image/jpeg, image/png",
                    },
                    on: {
                      change: function ($event) {
                        return _vm.showImagePreview($event)
                      },
                    },
                  }),
                  _c(
                    "b-button",
                    {
                      directives: [
                        {
                          name: "ripple",
                          rawName: "v-ripple.400",
                          value: "rgba(186, 191, 199, 0.15)",
                          expression: "'rgba(186, 191, 199, 0.15)'",
                          modifiers: { 400: true },
                        },
                      ],
                      attrs: { variant: "outline-secondary", size: "sm" },
                      on: { click: _vm.clearImage },
                    },
                    [_vm._v(" Reset ")]
                  ),
                  _vm.fileSizeError
                    ? _c("p", { staticClass: "text-danger" }, [
                        _vm._v(_vm._s(_vm.fileSizeError)),
                      ])
                    : _vm._e(),
                  _vm.fileTypeError
                    ? _c("p", { staticClass: "text-danger" }, [
                        _vm._v(_vm._s(_vm.fileTypeError)),
                      ])
                    : _vm._e(),
                  _c("b-card-text", [_vm._v("Allowed JPG. Max size of 800kB")]),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _c(
        "b-form",
        { staticClass: "mt-2" },
        [
          _c(
            "b-row",
            [
              _c(
                "b-col",
                { attrs: { sm: "6" } },
                [
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        label: "Username",
                        "label-for": "account-username",
                      },
                    },
                    [
                      _c("b-form-input", {
                        attrs: {
                          placeholder: "Username",
                          name: "username",
                          readonly: "",
                        },
                        model: {
                          value: _vm.generalData.userName,
                          callback: function ($$v) {
                            _vm.$set(_vm.generalData, "userName", $$v)
                          },
                          expression: "generalData.userName",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "b-col",
                { attrs: { sm: "6" } },
                [
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        label: "First Name",
                        "label-for": "account-name",
                      },
                    },
                    [
                      _c("b-form-input", {
                        attrs: { name: "name", placeholder: "First Name" },
                        model: {
                          value: _vm.generalData.firstName,
                          callback: function ($$v) {
                            _vm.$set(_vm.generalData, "firstName", $$v)
                          },
                          expression: "generalData.firstName",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "b-col",
                { attrs: { sm: "6" } },
                [
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        label: "Last Name",
                        "label-for": "account-name",
                      },
                    },
                    [
                      _c("b-form-input", {
                        attrs: { name: "name", placeholder: "Last Name" },
                        model: {
                          value: _vm.generalData.lastName,
                          callback: function ($$v) {
                            _vm.$set(_vm.generalData, "lastName", $$v)
                          },
                          expression: "generalData.lastName",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "b-col",
                { attrs: { sm: "6" } },
                [
                  _c(
                    "b-form-group",
                    {
                      attrs: { label: "E-mail", "label-for": "account-e-mail" },
                    },
                    [
                      _c("b-form-input", {
                        attrs: {
                          name: "email",
                          placeholder: "Email",
                          readonly: "",
                        },
                        model: {
                          value: _vm.generalData.email,
                          callback: function ($$v) {
                            _vm.$set(_vm.generalData, "email", $$v)
                          },
                          expression: "generalData.email",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "b-col",
                { attrs: { sm: "6" } },
                [
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        label: "Phone Number",
                        "label-for": "account-Number",
                      },
                    },
                    [
                      _c("b-form-input", {
                        attrs: { name: "Number", placeholder: "Phone Number" },
                        model: {
                          value: _vm.generalData.phoneNumber,
                          callback: function ($$v) {
                            _vm.$set(_vm.generalData, "phoneNumber", $$v)
                          },
                          expression: "generalData.phoneNumber",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "b-col",
                { staticClass: "mt-75", attrs: { cols: "12" } },
                [
                  _vm.generalData.isActive
                    ? _c(
                        "b-alert",
                        {
                          staticClass: "mb-50",
                          attrs: { show: "", variant: "success" },
                        },
                        [
                          _c("h4", { staticClass: "alert-heading" }, [
                            _vm._v(" This user is currently active. "),
                          ]),
                        ]
                      )
                    : _vm._e(),
                  !_vm.generalData.isActive
                    ? _c(
                        "b-alert",
                        {
                          staticClass: "mb-50",
                          attrs: { show: "", variant: "warning" },
                        },
                        [
                          _c("h4", { staticClass: "alert-heading" }, [
                            _vm._v(" This user is currently inactive. "),
                          ]),
                        ]
                      )
                    : _vm._e(),
                ],
                1
              ),
              _c(
                "b-col",
                { staticClass: "mt-75", attrs: { cols: "12" } },
                [
                  !_vm.generalData.emailConfirmed
                    ? _c(
                        "b-alert",
                        {
                          staticClass: "mb-50",
                          attrs: { show: "", variant: "warning" },
                        },
                        [
                          _c("h4", { staticClass: "alert-heading" }, [
                            _vm._v(
                              " Your email is not confirmed. Please check your inbox. "
                            ),
                          ]),
                        ]
                      )
                    : _vm._e(),
                  _vm.generalData.emailConfirmed
                    ? _c(
                        "b-alert",
                        {
                          staticClass: "mb-50",
                          attrs: { show: "", variant: "success" },
                        },
                        [
                          _c("h4", { staticClass: "alert-heading" }, [
                            _vm._v(" Your email is confirmed. "),
                          ]),
                        ]
                      )
                    : _vm._e(),
                ],
                1
              ),
              _c(
                "b-col",
                { attrs: { cols: "12" } },
                [
                  _c(
                    "b-button",
                    {
                      directives: [
                        {
                          name: "ripple",
                          rawName: "v-ripple.400",
                          value: "rgba(255, 255, 255, 0.15)",
                          expression: "'rgba(255, 255, 255, 0.15)'",
                          modifiers: { 400: true },
                        },
                      ],
                      staticClass: "mt-2 mr-1",
                      attrs: { variant: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.UpdateUser()
                        },
                      },
                    },
                    [_vm._v(" Save changes ")]
                  ),
                  _c(
                    "b-button",
                    {
                      directives: [
                        {
                          name: "ripple",
                          rawName: "v-ripple.400",
                          value: "rgba(186, 191, 199, 0.15)",
                          expression: "'rgba(186, 191, 199, 0.15)'",
                          modifiers: { 400: true },
                        },
                      ],
                      staticClass: "mt-2",
                      attrs: { variant: "outline-secondary", type: "reset" },
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _vm.resetForm($event)
                        },
                      },
                    },
                    [_vm._v(" Reset ")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }